import React from 'react';
import { motion } from 'framer-motion';
export const RevelationSection = () => {
  return <section className="py-20 sm:py-32 px-4 bg-brand-light" data-id="element-123">
      <div className="max-w-4xl mx-auto" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-125">
          <h2 className="font-serif text-3xl sm:text-5xl font-bold text-brand-dark mb-10 leading-tight" data-id="element-126">
            But there is a{' '}
            <span className="text-brand-accent" data-id="element-127">"Blue Ocean"</span> of
            opportunity.
          </h2>

          <div className="space-y-8 text-lg sm:text-xl text-brand-dark/80 leading-relaxed text-left max-w-3xl mx-auto" data-id="element-128">
            <p data-id="element-129">
              While everyone else is wasting time with "5,000 useless prompt
              lists," a small elite of professionals discovered the{' '}
              <span className="font-bold text-brand-dark bg-brand-gold/20 px-2 py-1 rounded" data-id="element-130">
                Strategic Context Injection (SCI)
              </span>{' '}
              method.
            </p>

            <p className="font-serif text-2xl text-brand-dark font-medium italic text-center py-4" data-id="element-131">
              They aren't working harder; they are architecting systems.
            </p>

            <p data-id="element-132">
              I've condensed this $10M strategy into a tactical manual designed
              for the busy professional who doesn't have time for a 40-hour
              course.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};